export default __webpack_public_path__ + "static/media/banner_16.60d88cc0.png";